import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ADS_GENERATION_INITIAL_VALUES, ADS_TAB_INITIAL_STATE} from './adsTab.consts';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {
  SocialAd,
  SocialAdMediaRenderingStatus,
  AdsRenderingStatus,
  AdStatusInfo,
  GenerateAdsStatus,
  GenerateAdsChanges,
  GenerateAdsValidationIssue,
} from 'common/src/modules/externalAds/externalAds.types';
import {AdsTableModalAction} from './adsTab.types';
import {MediaStatusResponse} from 'common/src/modules/media/media.types';

const adsTabSlice = createSlice({
  name: BreadcrumbName.CampaignAds,
  initialState: ADS_TAB_INITIAL_STATE,
  reducers: {
    resetAdsTab: () => ADS_TAB_INITIAL_STATE,
    updateAds: (state, action: PayloadAction<SocialAd[]>) => {
      state.ads = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state._loading = action.payload;
    },
    updateMediaRenderingStatus: (
      state,
      action: PayloadAction<Record<number, SocialAdMediaRenderingStatus>>,
    ) => {
      state.mediaRenderingStatus = action.payload;
    },
    updateAdsRenderingStatus: (state, action: PayloadAction<AdsRenderingStatus>) => {
      state.adsRenderingStatus = action.payload;
    },
    updateAdsStatusInfo: (state, action: PayloadAction<Record<string, AdStatusInfo>>) => {
      state.adsStatusInfo = action.payload;
    },
    setAdsStatusInfoLoading: (state, action: PayloadAction<boolean>) => {
      state.adsStatusInfoLoading = action.payload;
    },
    updateAdsLastUpdateTime: (state, action: PayloadAction<string>) => {
      state.adsLastUpdateTime = action.payload;
    },
    updatePrevVersionAdCount: (state, action: PayloadAction<number>) => {
      state.prevVersionAdCount = action.payload;
    },
    updateAdsGenerationStatus: (state, action: PayloadAction<GenerateAdsStatus>) => {
      state.adsGeneration.status = action.payload;
    },
    updateAdsGenerationInProgress: (state, action: PayloadAction<boolean>) => {
      state.adsGeneration.inProgress = action.payload;
    },
    updateAdsGenerationChanges: (state, action: PayloadAction<GenerateAdsChanges>) => {
      state.adsGeneration.changes = action.payload;
    },
    updateAdsGenerationIssues: (state, action: PayloadAction<GenerateAdsValidationIssue[]>) => {
      state.adsGeneration.issues = action.payload;
    },
    resetAdsGenerationValues: (state) => {
      state.adsGeneration = ADS_GENERATION_INITIAL_VALUES;
    },
    setModalAction: (state, action: PayloadAction<AdsTableModalAction>) => {
      state.modalAction = action.payload;
    },
    setShowAdsWithIssuesFilter: (state, action: PayloadAction<boolean>) => {
      state.showAdsWithIssuesFilter = action.payload;
    },
    setSelectedRows: (state, action: PayloadAction<number[]>) => {
      state.selectedRowIds = action.payload;
    },
    setDV360CampaignSyncing: (state, action: PayloadAction<boolean>) => {
      state.dv360CampaignSyncing = action.payload;
    },
    setDV360CVSdownloadInProgress: (state, action: PayloadAction<boolean>) => {
      state.dv360CVSdownloadInProgress = action.payload;
    },
    setMediaRenderingStatuses: (state, action: PayloadAction<MediaStatusResponse[]>) => {
      state.mediaRenderingStatuses = action.payload;
    },
    setAreAdsUpdated: (state, action: PayloadAction<boolean>) => {
      state.areAdsUpdated = action.payload;
    },
    setCanBeSkippedToPublish: (state, action: PayloadAction<boolean>) => {
      state.canBeSkippedToPublish = action.payload;
    },
  },
});

export const {
  resetAdsTab,
  updateAds,
  setLoading,
  updateMediaRenderingStatus,
  updateAdsRenderingStatus,
  updateAdsStatusInfo,
  setAdsStatusInfoLoading,
  updateAdsLastUpdateTime,
  updatePrevVersionAdCount,
  updateAdsGenerationStatus,
  updateAdsGenerationInProgress,
  updateAdsGenerationChanges,
  updateAdsGenerationIssues,
  resetAdsGenerationValues,
  setModalAction,
  setShowAdsWithIssuesFilter,
  setSelectedRows,
  setDV360CampaignSyncing,
  setDV360CVSdownloadInProgress,
  setMediaRenderingStatuses,
  setAreAdsUpdated,
  setCanBeSkippedToPublish,
} = adsTabSlice.actions;
export default adsTabSlice.reducer;
